import {
  DictionaryAutocomplete,
  useListSource,
  useAutocompleteSource,
} from '@eas/common-web';
import { useTicketListSource } from '../../../common/use-ticket-list-source';
import { Notice, Program, SpecificTarget } from '../../../common/models';

export function useProjectPhases() {
  return useListSource<DictionaryAutocomplete>({
    url: '/api/ks/public/dictionary/project-phases/all',
  });
}

export function useRegions() {
  return useListSource<DictionaryAutocomplete>({
    url: '/api/ks/public/dictionary/regions/all',
  });
}

export function usePrograms() {
  return useListSource<DictionaryAutocomplete>({
    url: '/api/ks/public/dictionary/programs/all',
  });
}

export function useSpecificTargets(programs: Program[] | null = []) {
  return useTicketListSource<DictionaryAutocomplete>({
    url: withParentIds(
      '/api/ks/public/dictionary/specific-targets/all',
      'programIds',
      programs
    ),
  });
}

export function useNotices(specificTargets: SpecificTarget[] | null = []) {
  return useTicketListSource<DictionaryAutocomplete>({
    url: withParentIds(
      '/api/ks/public/dictionary/notices/all',
      'specificTargetIds',
      specificTargets
    ),
  });
}

export function useActivities(notices: Notice[] | null = []) {
  return useTicketListSource<DictionaryAutocomplete>({
    url: withParentIds(
      '/api/ks/public/dictionary/activities/all',
      'noticeIds',
      notices
    ),
  });
}

export function useTags() {
  return useAutocompleteSource<DictionaryAutocomplete>({
    url: '/api/ks/public/dictionary/tags/autocomplete',
  });
}

function withParentIds(
  url: string,
  parameter: string,
  parents: { id: string }[] | null | undefined
) {
  const query = (parents ?? [])
    .map(({ id }) => `${parameter}=${encodeURIComponent(id)}`)
    .join('&');

  return query === '' ? url : `${url}?${query}`;
}
